import { moduleProviderFactory } from "mrb/core";
import { EmbeddedAppRelease, HandheldAppRelease, HandheldPinkAppRelease } from "administration/app-release/pages";
import {
    EmbeddedAppReleaseRouteStore,
    HandheldAppReleaseRouteStore,
    HandheldPinkAppReleaseRouteStore,
} from "administration/app-release/stores";
import { nakiRadioRoles } from "common/constants";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "AppRelease",
        routes: [
            {
                name: "master.administration.app-release",
                pattern: "/app-release",
                authorization: [`roles:${nakiRadioRoles.accountOwnerRoleName}`],
                children: [
                    {
                        name: "master.administration.app-release.embedded",
                        pattern: "/embedded",
                        authorization: [`roles:${nakiRadioRoles.accountOwnerRoleName}`],
                        component: EmbeddedAppRelease,
                        store: EmbeddedAppReleaseRouteStore,
                        data: {
                            title: "ADMINISTRATION.APP_RELEASE.TITLE.EMBEDDED",
                        },
                    },
                    {
                        name: "master.administration.app-release.handheld",
                        pattern: "/kedayo",
                        authorization: [`roles:${nakiRadioRoles.accountOwnerRoleName}`],
                        component: HandheldAppRelease,
                        store: HandheldAppReleaseRouteStore,
                        data: {
                            title: "ADMINISTRATION.APP_RELEASE.TITLE.HANDHELD",
                        },
                    },
                    {
                        name: "master.administration.app-release.handheld-pink",
                        pattern: "/kedayo-pink",
                        authorization: [`roles:${nakiRadioRoles.accountOwnerRoleName}`],
                        component: HandheldPinkAppRelease,
                        store: HandheldPinkAppReleaseRouteStore,
                        data: {
                            title: "ADMINISTRATION.APP_RELEASE.TITLE.HANDHELD_PINK",
                        },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.APP_RELEASE_CENTER",
                order: 17,
                icon: "settings",
                authorization: [`roles:${nakiRadioRoles.accountOwnerRoleName}`],
                subMenu: [
                    {
                        title: "ADMINISTRATION.MENU.APP_RELEASE_EMBEDDED",
                        order: 1,
                        route: "master.administration.app-release.embedded",
                    },
                    {
                        title: "ADMINISTRATION.MENU.APP_RELEASE_HANDHELD",
                        order: 2,
                        route: "master.administration.app-release.handheld",
                    },
                    {
                        title: "ADMINISTRATION.MENU.APP_RELEASE_HANDHELD_PINK",
                        order: 3,
                        route: "master.administration.app-release.handheld-pink",
                    },
                ],
            },
        ],
    });
})();
